import React, { useState } from "react";
import { Questionnaire, QuestionnaireDefinition } from "../common/models";
import { QuestionnaireTaskView } from "../common/QuestionnaireTaskView";


const Definition: QuestionnaireDefinition = {
  name: 'Voice Perception',
  key: 'voiceQualityPerception',
  title: 'Voice Perception',
  description: '',
  cohort: 'generic',
  type: 'questionnaire',
  estimatedCompletionTime: '0:15',
  groups: [
    {
      key: 'voiceQualityPerceptionInformation',
      title: '',
      description: '',
      questions: [
        {
          key: 'value',
          type: 'multiple-choice',
          question: 'How would you rate your voice today from 1-10?',
          hint: '1=lowest rating, 10=highest rating',
          options: [
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' },
            { key: '6', displayName: '6' },
            { key: '7', displayName: '7' },
            { key: '8', displayName: '8' },
            { key: '9', displayName: '9' },
            { key: '10', displayName: '10' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        }
      ]
    }
  ]
};
export const VoicePerceptionDefinition = Definition;

export const VoicePerception = ({onCompletion}: {onCompletion: () => void}) => {
  const [questionnaire, setQuestionnaire] = useState<Questionnaire>(() => ({
    id: 'voiceQualityPerceptions',
    ...Definition,
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'in-progress',
  }));

  console.log('VoicePerception component rendered', questionnaire);

  const handleOnCompletion = () => {
    console.log('Voice Perception completed');

    onCompletion();
  };

  const handleOnChange = (questionnaire: Questionnaire) => {
    console.log('questionnaire', questionnaire);
    setQuestionnaire(questionnaire);
  }

  console.log('VoicePerception component rendered', questionnaire);

  return (
    <div>
      <QuestionnaireTaskView questionnaire={questionnaire} onChange={handleOnChange} onCompletion={handleOnCompletion  } />
    </div>
  );
}
